import * as yup from 'yup';

export const streamCreateSchema = (
  t: (key: string, options?: { [key: string]: string }) => string,
): yup.AnyObjectSchema =>
  yup.object().shape({
    name: yup.string().required(t('streams.create.errors.missingName')).max(255, t('streams.create.errors.tooLong')),
  });
